<section class="platinum-page hero-bg">
    <div class="max-w-5xl mx-auto px-5 py-20 flex-col gap-6 sm:gap-8 sm:h-screen flex justify-center items-center">
        <div>
            <img src="https://imgix.cosmicjs.com/f1326170-6612-11ef-80bb-ff60e40f80b5-Dimers-Platinum-Logo---Highlights.png?auto=format,compress"
                alt="platinum" width="620" height="76" loading="lazy">
        </div>
        <div class="flex justify-center">
            <h1
                class="text-xl md:text-4xl lg:text-5xl font-bold text-white overflow-hidden whitespace-nowrap border-r-4 border-r-white animate-typing">
                AI football bets
                <span class="text-turquoise font-bold"> that actually win</span>
            </h1>
        </div>

        <p class="text-base text-white text-center leading-7">
            Dimers Platinum is our most advanced AI sports betting tool—powered by reinforcement learning and trained for <b>profit</b>.
        </p>

        <div class="flex flex-col gap-2 items-center">
            <div class="text-xs sm:text-base text-white flex gap-1.5 sm:gap-6 items-center">
                <div class="flex items-center">
                    <img src="https://imgix.cosmicjs.com/c09b3620-4cbe-11f0-b7a6-1b6e330f9eb6-bolt.svg?auto=format,compress"
                        alt="icon" width="24" height="24" loading="lazy" class="w-4 h-4 sm:w-6 sm:h-6 mr-2">
                    +42.06 units
                </div>
                <div class="flex items-center">
                    <img src="https://imgix.cosmicjs.com/c09a99e0-4cbe-11f0-b7a6-1b6e330f9eb6-dollar-sign.svg?auto=format,compress"
                        alt="icon" width="24" height="24" loading="lazy" class="w-4 h-4 sm:w-6 sm:h-6 mr-2">
                    +28.38% ROI
                </div>
                <div class="flex items-center">
                    <img src="https://imgix.cosmicjs.com/c099fda0-4cbe-11f0-b7a6-1b6e330f9eb6-crown.svg?auto=format,compress"
                        alt="icon" width="24" height="24" loading="lazy" class="w-4 h-4 sm:w-6 sm:h-6 mr-2">
                    69% strike rate
                </div>
            </div>
            <div class="text-5xl text-white font-bold text-center">
                105-46-2
            </div>
            <div class="text-xl text-gray-400 text-center">
                2024 CFB Season Record
            </div>
        </div>
        <div class="flex items-start sm:items-center justify-center mt-4 gap-1.5 text-xs sm:text-base">
            <div>
                <img src="https://imgix.cosmicjs.com/a0ee5b60-4cc1-11f0-b7a6-1b6e330f9eb6-rocket.svg?auto=format,compress"
                    alt="icon" width="24" height="24" loading="lazy" class="w-4 h-4 sm:w-6 sm:h-6">
            </div>
            <p class="text-left">
                Returning this August. Early bird pricing. Limited spots.
            </p>
        </div>
        <div class="w-full max-w-xl">
            <div class="flex justify-center">
                <button (click)="jumpToSection('pricing')"
                    class="px-6 h-10 flex items-center justify-center rounded-md whitespace-nowrap bg-turquoise text-base text-gray-900 font-semibold">
                    Get AI Picks
                </button>
            </div>
            <!-- <app-waitlist-form></app-waitlist-form> -->
            <div class="mt-6 flex justify-center">
                <app-countdown-timer></app-countdown-timer>
            </div>
        </div>
        <!-- <div class="flex flex-wrap justify-center gap-3">
            <div *ngFor="let stat of stats" class="flex items-center gap-x-3 rounded-lg bg-turquoise/10 px-4 py-2">
                <div>
                    <img [src]="stat.iconUrl" alt="icon" width="24" height="24" loading="lazy">
                </div>
                <span class="text-sm text-gray-300">{{ stat.label }}</span>
                <span class="text-sm font-semibold text-white">{{ stat.value }}</span>
            </div>
        </div> -->
    </div>
</section>

<section>
    <div class="bg-platinum text-white py-16 sm:py-20">
        <div class="max-w-5xl mx-auto px-5">
            <div class="flex flex-col lg:flex-row gap-x-4 gap-y-4 items-center">
                <div class="lg:basis-2/3">
                    <h2 class="text-3xl sm:text-4xl font-bold tracking-tight">
                        Smarter AI betting through <span class="text-turquoise">reinforcement learning</span>
                    </h2>
                <p class="mt-6 text-lg leading-8 text-gray-300">
                    Dimers Platinum doesn't follow trends—it learns from them. Our football prediction AI is trained using reinforcement
                    learning, where an “agent” (think: a bettor) is rewarded for profitable picks and penalized for losses.
                </p>
                <p class="mt-4 text-lg leading-8 text-gray-300">
                    This feedback loop allows the model to continuously improve, maximizing long-term value in volatile betting markets.
                    The result? A smarter, more adaptable system for AI football predictions that’s built to spot inefficiencies fast.
                </p>
                </div>
            
                <div class="lg:basis-1/3">
                    <video *ngIf="isBrowser" #videoPlayer class="sm:w-80 sm:h-80 bg-white/5 rounded-2xl flex items-center justify-center ring-1 ring-white/10 shadow-2xl shadow-cyan-500/20
                             " autoplay loop muted playsinline>
                        <source src="https://cdn.cosmicjs.com/55d6f400-5894-11f0-ae5a-0f56aa053fcd-2.mp4?auto=format,compress"
                            type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </div>
            </div>

            <div class="mt-8 pt-8 border-t border-white/10 flex items-center gap-x-4">
                <div class="flex items-center">
                    <div class="w-12 h-12 rounded-full bg-gray-700 flex-none flex items-center justify-center border border-gray-400">
                        <img src="https://imgix.cosmicjs.com/9a4e0b30-d1f6-11ee-babb-b99b48a02ac8-dimers-pro-logo.svg?auto=format,compress"
                            alt="dimes pro icon" width="32" height="32" loading="lazy">
                    </div>
                    <div class="w-12 h-12 rounded-full bg-cyan-800 flex-none flex items-center justify-center border border-gray-400 -ml-5">
                        <img src="https://imgix.cosmicjs.com/f7c98b80-6612-11ef-80bb-ff60e40f80b5-Dimers-Platinum-Icon---Highlights.png?auto=format,compress&w=100"
                            alt="Dimers Platinum icon" width="32" height="32" loading="lazy">
                    </div>
                </div>

                    <p class="text-base text-gray-300 italic">
                        Dimers Platinum is not Dimers Pro. Nothing shared with Platinum subscribers appears on <a href="https://www.dimers.com/" target="_blank" class="underline">Dimers.com</a>  or in any Pro plan. This is a different beast entirely.
                    </p>
                </div>
        </div>
    </div>
</section>

<section id="pricing">
    <div class="bg-[#000A11] py-16 sm:py-20">
        <div class="mx-auto max-w-5xl px-5">
            <div class="mx-auto max-w-4xl text-center">
                <h2 class="text-3xl font-bold tracking-tight text-white sm:text-4xl">
                    Dimers Platinum <span class="text-turquoise">Pricing</span>
                </h2>
            </div>
            <div class="mt-12">
                <app-pricing-card></app-pricing-card>
            </div>

        </div>
    </div>
</section>

<section>
    <app-season-results-section></app-season-results-section>
</section>

    <app-features-and-results-section></app-features-and-results-section>
    
    <app-testimonials-section></app-testimonials-section>

    <app-benefits-section></app-benefits-section>

    <app-closing-sections [jumpToSection]="jumpToSection"></app-closing-sections>
    
<section class="bg-platinum" #section id="faq">
    <app-faq-section></app-faq-section>
</section>


